// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeNotificationSettingsApplyPresetBody = {
  presetId: "everything" | "essentials" | "quiet";
};

export type typeNotificationSettingsApplyPresetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { appliedPresetId: string; updatedCount: number };
};

export type typeNotificationSettingsApplyPresetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsApplyPresetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsApplyPresetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaNotificationSettingsApplyPresetBody = {
  type: "object",
  properties: {
    presetId: { type: "string", enum: ["everything", "essentials", "quiet"] },
  },
  required: ["presetId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createNotificationSettingsApplyPreset(
  options: SdkOptions,
) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaNotificationSettingsApplyPresetBody);
  }

  return async function postNotificationSettingsApplyPreset(
    payload: typeNotificationSettingsApplyPresetBody,
  ): Promise<
    | typeNotificationSettingsApplyPresetOutput200
    | typeNotificationSettingsApplyPresetOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postNotificationSettingsApplyPreset" failed before calling the network. #f77e2fe51149`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#f77e2fe51149" },
        },
        data: null,
      } as typeNotificationSettingsApplyPresetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/notification-settings/apply-preset`,
      httpMethod: "POST",
      options,
    })) as
      | typeNotificationSettingsApplyPresetOutput200
      | typeNotificationSettingsApplyPresetOutput400;
  };
}
